import styled from "styled-components";

export const AddModal = styled.div`
  display: flex;
  flex-direction: column;
  width: 25rem;

  h1 {
    font-size: 1.5rem;
  }

  .input {
    margin-bottom: 1rem;
  }

  .divider {
    margin: 0.4rem 0;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar {
    width: 6px;
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #000000;
  }
`;
